import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';

export const findPointsRule = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/points_rule?`+params,
        method: 'GET'
    })
}

export const findPointsRuleAll = () => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/points_rule`,
        method: 'GET'
    })
}
export const choose = (type) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/points_rule/choose?type=`+type,
        method: 'GET'
    })
}
export const addPointsRule = (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/points_rule`,
        method: 'POST',
        data: data
    })
}

export const editPointsRule = (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/points_rule`,
        method: 'PUT',
        data: data
    })
}

export const delPointsRule = (deleteOption, ids) => {
    let temp = ids.join(",")
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/points_rule/${temp}?option=${deleteOption}`,
        method: 'DELETE'
    })
}